<template>
  <switch-dialog :visible="visible" @cancel="close">
    <div class="hotel-dialog">
      <div class="hotel-list" @click="toDetail">
        <div class="hotel-swiper">
          <swiper
            :options="options"
            @slideChange="change"
            ref="swiper"
            class="swiper-container"
          >
            <swiper-slide
              :style="{ backgroundImage: `url(${item.path})` }"
              v-for="(item, index) in images"
              :key="index"
              class="swiper-slide cover"
            >
            </swiper-slide>
          </swiper>
          <div class="currents">{{ current + 1 }}/{{ images.length }}</div>
        </div>
        <div class="middle-info middle-flex">
          <div class="title ellipsis">{{ data.name }}</div>
          <div class="price" v-if="priceVisible && data.min_price > 1">¥{{ data.min_price }}起</div>
        </div>
        <div class="desc">
          <div class="content ellipsis">“{{ data.profile || "-" }}”</div>
        </div>
      </div>
    </div>
  </switch-dialog>
</template>

<script>
import qs from "@halobear/utils/qs";

import { Swiper, SwiperSlide } from "@/components/swiper";
import switchDialog from "@/components/switch-dialog";
import { toService } from "@/utils/to";

export default {
  components: {
    Swiper,
    SwiperSlide,
    switchDialog,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    visible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      current: 0,
    };
  },
  computed: {
    swiper() {
      return (this.$refs.swiper || {}).$swiper;
    },
    images() {
      const route = this.$route;
      // 兼容App内部全景
      const query = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split("?")[1] || "");
      const { picture = [] } = this.data;
      const images = picture.filter((item) => item.path);
      return query.phone ? images.slice(0, 1) : images;
    },
    options() {
      return {
        loop: this.images.length > 1,
        spaceBetween: 5,
      };
    },
    priceVisible() {
      const route = this.$route;
      const query = route.query.hall_id
        ? route.query
        : qs.parse(window.location.search.split("?")[1] || "");
      return !query.phone;
    },
  },
  methods: {
    change(e) {
      this.current = e.activeIndex;
    },
    close() {
      this.$emit("update:visible", false);
    },
    toDetail() {
      this.close();
      toService(this.data.id);
    },
  },
};
</script>

<style lang="less" scoped>
.hotel-list {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  width: 670px;
  margin: 0 auto;
  padding-bottom: 64px;
  &::-webkit-scrollbar {
    display: none;
  }
  .hotel-item {
    text-align: center;
  }
  .hotel-swiper {
    width: 670px;
    height: 446px;
    position: relative;
    .swiper-container {
      width: 100%;
      height: 100%;
    }
    .currents {
      z-index: 2;
      position: absolute;
      background-color: rgba(0, 0, 0, 0.5);
      padding: 2px 20px;
      font-size: 24px;
      font-weight: 400;
      color: #ffffff;
      line-height: 34px;
      border-radius: 20px;
      bottom: 20px;
      right: 20px;
    }
  }
  .middle-info {
    padding: 24px 0 16px 0;
  }
  .title {
    font-size: 32px;
    flex: 1;
    font-weight: bold;
    color: #323038;
    line-height: 44px;
  }
  .price {
    font-size: 26px;
    font-weight: bold;
    flex-shrink: 0;
    margin-left: 20px;
    color: #383130;
    line-height: 36px;
  }
  .desc {
    display: flex;
    .content {
      width: auto;
      background: #f3f3f3;
      border-radius: 4px;
      font-size: 24px;
      font-weight: 400;
      color: #68676c;
      line-height: 34px;
      padding: 4px 12px;
      max-width: 670px;
    }
  }
}
.blank-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #999;
  font-size: 30px;
  padding: 80px 0;
  .blank-icon {
    width: 330px;
    height: 330px;
    object-fit: contain;
    object-position: center center;
    margin-bottom: 60px;
  }
}
</style>
